<template>
  <div class="pt-2 secondary">
    <div class="text-h6 text-center mb-2">{{ groupName }} | {{ itemName }}</div>

    <l-map
      :zoom="zoom"
      :center="center"
      :options="mapOptions"
      style="height: 40vh"
      class="mb-6"
    >
      <l-tile-layer :url="url" :attribution="attribution" />

      <l-marker
        v-for="marker in markers"
        :key="marker.id"
        :lat-lng.sync="marker.position"
        :draggable="true"
        ref="marker"
      >
        <l-popup :open="true">
          <div class="pin-wrapper px-2">
            <v-text-field
              label="Τίτλος"
              color="primary"
              dense
              outlined
              hide-details
              class="mb-2"
            ></v-text-field>

            <v-textarea
              dense
              outlined
              hide-details
              color="primary"
              class="mb-4"
              no-resize
              label="Περιγραφή"
            ></v-textarea>

            <v-file-input
              accept="video/mp4,video/x-m4v,video/*"
              v-model="video"
              ref="video"
              id="videoInput"
              v-show="false"
              @change="onVideoChange"
            >
            </v-file-input>

            <v-file-input
              accept="image/png, image/jpeg, image/jpg"
              v-model="photo"
              ref="photo"
              id="photoInput"
              v-show="false"
            >
            </v-file-input>

            <v-row class="mb-5" no-gutters>
              <v-col cols="4" class="mr-2">
                <div class="file-wrapper rounded">
                  <label
                    class="
                      d-flex
                      flex-column
                      align-center
                      justify-center
                      add-file
                      primary
                      pa-2
                      rounded
                    "
                    for="photoInput"
                  >
                    <v-icon color="white" class="mb-2">mdi-plus</v-icon>
                    <div class="body-2 white--text text-center">Add Photo</div>
                  </label>
                </div>
              </v-col>

              <v-col cols="4" class="mr-2">
                <div class="file-wrapper rounded">
                  <label
                    class="
                      d-flex
                      flex-column
                      align-center
                      justify-center
                      add-file
                      primary
                      pa-2
                      rounded
                    "
                    for="videoInput"
                  >
                    <v-icon color="white" class="mb-2">mdi-plus</v-icon>
                    <div class="body-2 white--text text-center">Add video</div>
                  </label>
                </div>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="4" class="mr-2">
                <div class="file-wrapper rounded" v-if="photoPreview">
                  <div
                    class="
                      file-overlay
                      d-flex
                      flex-column
                      align-center
                      justify-center
                      rounded
                    "
                  >
                    <v-btn
                      icon
                      small
                      color="error"
                      @click.stop="deletePhoto(photoPreview)"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </div>

                  <img :src="photoPreview.preview" class="rounded" />
                </div>
              </v-col>

              <v-col cols="4" class="mr-2">
                <div class="file-wrapper rounded" v-if="thumbnail && video">
                  <div
                    class="
                      file-overlay
                      d-flex
                      flex-column
                      align-center
                      justify-center
                      rounded
                    "
                  >
                    <v-btn icon small color="error" @click.stop="deleteVideo()">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </div>

                  <img :src="thumbnail" />
                </div>
              </v-col>
            </v-row>
          </div>
        </l-popup>
      </l-marker>
    </l-map>

    <div class="body-2">Drag marker to a position of your choice.</div>

    <div class="body-2 mb-2">Click on a marker to add information</div>

    <v-btn depressed small color="primary" @click="newMarker"
      >Add Location</v-btn
    >
  </div>
</template>

<script>
import { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup, LTooltip } from "vue2-leaflet";
import { nanoid } from "nanoid";

export default {
  props: ["groupName", "itemName"],
  name: "Example",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LTooltip,
  },
  data() {
    return {
      zoom: 13,
      center: latLng(37.9862245, 23.7257264),
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      mapOptions: {
        zoomSnap: 0.5,
      },
      markers: [],
      video: null,
      thumbnail: null,
      photo: null,
    };
  },
  computed: {
    photoPreview() {
      if (!this.photo) return;

      const size = this.photo.size / 1024 / 1024;
      const roundedSize = Math.round((size + Number.EPSILON) * 100) / 100;

      return {
        photo: this.photo,
        size: roundedSize,
        name: this.photo.name,
        preview: URL.createObjectURL(this.photo),
      };
    },
  },
  methods: {
    async newMarker() {
      this.markers.push({
        id: nanoid(),
        position: { lng: 23.7257264, lat: 37.9862245 },
      });

      this.center = latLng(37.9862245, 23.7257264);

      await this.$nextTick();
      console.log(this.$refs.marker[0].mapObject.openPopup());
    },
    getVideoCover(file, seekTo = 0.0) {
      console.log("getting video cover for file: ", file);
      return new Promise((resolve, reject) => {
        // load the file to a video player
        const videoPlayer = document.createElement("video");
        videoPlayer.setAttribute("src", URL.createObjectURL(file));
        videoPlayer.load();
        videoPlayer.addEventListener("error", (ex) => {
          reject("error when loading video file", ex);
        });
        // load metadata of the video to get video duration and dimensions
        videoPlayer.addEventListener("loadedmetadata", () => {
          // seek to user defined timestamp (in seconds) if possible
          if (videoPlayer.duration < seekTo) {
            reject("video is too short.");
            return;
          }
          // delay seeking or else 'seeked' event won't fire on Safari
          setTimeout(() => {
            videoPlayer.currentTime = seekTo;
          }, 200);
          // extract video thumbnail once seeking is complete
          videoPlayer.addEventListener("seeked", () => {
            console.log("video is now paused at %ss.", seekTo);
            // define a canvas to have the same dimension as the video
            const canvas = document.createElement("canvas");
            canvas.width = videoPlayer.videoWidth;
            canvas.height = videoPlayer.videoHeight;
            // draw the video frame to canvas
            const ctx = canvas.getContext("2d");
            ctx.drawImage(videoPlayer, 0, 0, canvas.width, canvas.height);
            // return the canvas image as a blob
            ctx.canvas.toBlob(
              (blob) => {
                resolve(blob);
              },
              "image/jpeg",
              0.75 /* quality */
            );
          });
        });
      });
    },
    async onVideoChange(video) {
      if (video) {
        const cover = await this.getVideoCover(this.video, 5);
        this.thumbnail = URL.createObjectURL(cover);
      }
    },
    deleteVideo() {
      this.video = null;
    },
    deletePhoto() {
      this.photo = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.pin-wrapper {
  width: 300px;
  height: 30vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.file-wrapper {
  padding-bottom: 100%;
  position: relative;

  .file-overlay {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(#000, 0.4);
    z-index: 1;
  }

  img {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  .add-file {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    cursor: pointer;
  }
}
</style>